module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/205.52dbe7c0.png";